import React, { useState } from "react";
import { ApplyBtn, ErrorText, StyledInput } from "./styles";
import CouponSuccess from "./couponSuccess";
import actions from "@actions/actionsMap";
import { useRouter } from "next/router";

const CouponInput = (props) => {
  const router = useRouter();
  const { proposal_ekey } = router.query;
  console.log("hike", props);
  const { ctaText, placeholder, isApplied, action, couponCode } = props;
  const [couponName, setCouponName] = useState<string>("");
  const [localError, setLocalError] = useState<string>("");

  const handleClickCoupon = (action, type) => {
    console.log('hike org')
    const setterFxn = actions?.[action?.on_click?.[0]?.type];

    const customArgs = {
      requestBody: {
        current_node: "checkout_review_node",
        expected_node: "checkout_review_node",
        journey: "fresh_car"
      },
      showCustomLottie: false,
      showCustomBasicLoader: true,
      customAnimationText: "DONT_SHOW_CUSTOM_TEXT",
      data: {
        status: type,
        couponId: type === "remove" ? couponCode : couponName,
        proposal_ekey: proposal_ekey
      }
    };

    if (action?.on_click?.[0] && typeof setterFxn === "function") {
      setterFxn(customArgs || {});
    }
  };

  const handleClick = (e) => {
    if (!couponName) {
      setLocalError("Enter a coupon code");
    } else {
      setLocalError("");
      handleClickCoupon(action, "add");
    }
  };

  return !isApplied ? (
    <div style={{ paddingBottom: (props?.error || localError) && "1rem" }}>
      <div
        style={{
          boxSizing: "border-box" ,
          width: "100%",
          position: "relative",
          height: "50px",
          borderRadius: "8px",
          border: `1px solid ${props?.error ? "#D83D37" : "#E7E7F0"}`
        }}
      >
        <>
          <StyledInput
            onChange={(e) => {
              setCouponName(e.target.value);
              setLocalError("");
            }}
            onBlur={props.blurHandler}
            name="couponCode"
            type="text"
            placeholder={placeholder || "Enter coupon code"}
            disabled={props.showLoader}
          />

          <ApplyBtn onClick={(e) => handleClick(couponName)}>
            {ctaText || "Apply"}
          </ApplyBtn>
        </>
        <div
          style={{
            marginTop: "6px"
          }}
        >
          <ErrorText>{props?.error || localError || ""}</ErrorText>
        </div>
      </div>
    </div>
  ) : (
      <CouponSuccess handleClickCoupon={handleClickCoupon} action={action} {...props} />
  );
};

export default CouponInput;
